<div class="landing-background" #scrollContainer>
  <div class="scene-container">

    <img src="assets/img/fondo2-prueba.png" alt="Showroom" class="img-responsive">

    <div *ngFor="let prod of productos"
         class="hotspot-dot"
         [style.top]="prod.top"
         [style.left]="prod.left"
         (click)="irAlDetalle(prod.slug)"> <div class="tooltip">
        <span class="nombre">{{ prod.nombre }}</span>
      </div>
    </div>

  </div>
</div>
